'use client';

import { useTranslations } from 'next-intl';
import { CustomImage as Image } from '../..';
import { useWindowSize } from 'hooks/dom/useWindowSize';
import styles from './DynamiCRecoveryModal.module.css';

export const DynamicRecoveryModal = ({
  className,
}: {
  className?: string;
}) => {
  const t = useTranslations('ring');
  const { width } = useWindowSize();

  return (
    <div
      className={className ? `${styles.root} ${className}` : styles.root}
      onClick={(e) => e.stopPropagation()}
      onKeyDown={(e) => e.stopPropagation()}
      role="button"
      tabIndex={0}
      aria-labelledby="dynamic-recovery-modal-heading"
    >
      <div className="container">
        <h4 id="dynamic-recovery-modal-heading">
          {t('ring.bentoRecoverySection.dynamicRecoveryCard.title')}
        </h4>
        <h3>{t('ring.bentoRecoverySection.dynamicRecoveryCard.subtitle')}</h3>
        <div className="modal-items">
          <div className="item">
            <p className="text-left">
              {t(
                'ring.bentoRecoverySection.dynamicRecoveryCard.modal.cardA.desc',
              )}
            </p>
            <div
              className="img-container"
              role="img"
              aria-label={t('dynamiCRecoveryModal.content.ariaLabelMobile')}
            >
              <Image
                src={'web_v2/ring-buy/recovery/png/flip/mobile.png'}
                fill
                alt=""
                className="recovery-flip-img"
                aria-hidden="true"
              />
            </div>
            {width > 992 ? (
              <div
                className="mask-container"
                role="img"
                aria-label={t('dynamiCRecoveryModal.content.ariaLabelMask')}
              >
                {' '}
                <Image
                  src={
                    'web_v2/ring-buy/recovery/svg/flip/recoveryFlipAMask.svg'
                  }
                  fill
                  alt=""
                  className="recovery-flip-img"
                  aria-hidden="true"
                />
              </div>
            ) : null}
          </div>
          <div className="item">
            <p className="text-mid">
              {t(
                'ring.bentoRecoverySection.dynamicRecoveryCard.modal.cardB.desc',
              )}
            </p>
            <div
              className="img-container"
              role="img"
              aria-label={t('dynamiCRecoveryModal.content.ariaLabel')}
            >
              <Image
                src={'web_v2/ring-buy/recovery/png/flip/recovery_nudge.png'}
                fill
                alt=""
                className="sleep-index"
                aria-hidden="true"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
